import { useGetDocument } from '@/api/endpoints/document/useGetDocument';
import { useAuth } from '@/context/AuthProvider';

import DocumentViewer from '@/components/document/DocumentViewer';

import ModalWithPreview from '../modals/ModalWithPreview';

interface Props {
  id: string;
  categoryId?: number;
  onClose: () => void;
}

const DocumentViewModal: React.FC<Props> = ({ id, categoryId, onClose }) => {
  const { session } = useAuth();
  const fetchDocumentQuery = useGetDocument(id, session);

  return (
    <ModalWithPreview
      onClose={onClose}
      title={fetchDocumentQuery.data?.original_name}
      maxWidth="xl"
    >
      <DocumentViewer id={id} session={session} layoutType="modal" />
    </ModalWithPreview>
  );
};

export default DocumentViewModal;
